import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class EmailReportStore {
  emailStore = [];
  reportNames = [];
  reportsList = [];
  groupList = [];
  subGroupList = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      emailStore: observable,
      loading: observable,
      reportNames: observable,
      reportsList: observable,
      total: observable,
      groupList: observable,
      subGroupList: observable,
      loadData: action,
      addData: action,
      getVehicles: action,
      deleteRecord: action,
      getEmailReportData: action,
      getReportsName: action,
      getVehicleGroup: action,
      getVehicleSubGroup: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, searchField, companyId }) {
    this.loading = true;

    // var postData = { companyId: companyId, offset: offset, limit: limit };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=emailreport&a=getErList", "postData=" + base64Input);

    const params = { companyId: companyId };

    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/EmailReport/getErList", { params });

    this.emailStore = response?.data?.data;
    this.total = parseInt(response.data?.TotalCount);
    this.loading = false;
  }
  async addData(emailReportData) {
    // var postData = emailReportData;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=emailreport&a=update", "postData=" + base64Input);

    const response = await postApi
      .getClient("")
      .post(
        config.NodeUrl + "/EmailReport/addUpdateEmailData",
        emailReportData
      );
    return response.data;
  }

  async getVehicles({ companyId }) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    this.vehicles = response.data.data;
    return response.data.data;
  }

  async deleteRecord({ er_Id }) {
    // const postData = { er_Id: er_Id };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=emailreport&a=delete", "postData=" + base64Input);

    const params = { er_Id };
    const response = await postApi
      .getClient("")
      .delete(config.NodeUrl + "/EmailReport/deleteEmailData", { params });
    return response;
  }

  async getEmailReportData(Id, companyId) {
    console.log("Id", Id, companyId, "companyId");
    // var postData = { Id: Id, companyId: companyId, limit: 1, offset: 0 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=emailreport&a=getErList", "postData=" + base64Input);
    const params = { Id: Id, companyId: companyId };
    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/EmailReport/getErList", { params });
    return response?.data?.data[0];
  }

  async getReportsName() {
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=report&a=getReport", "postData=" + base64Input);

    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/EmailReport/getReportsList");

    this.reportsList = response.data?.data;
    return response.data?.data;
  }

  async getVehicleGroup({ companyId, userId, isadmin }) {
    console.log("getdata");
    var postData = { companyId: companyId, userId: userId, isadmin: isadmin };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=devicegroup&a=getVehicleGropups",
    //     "postData=" + base64Input
    //   );
    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceGroup/getVehicleGroups", {
        params: postData,
      });
    this.groupList = response?.data?.VehicleGroupData;

    // this.groupList = response.data.data;
  }

  async getVehicleSubGroup({
    deviceGroupId,
    deviceSubGroupId,
    companyId,
    userId,
    isadmin,
    subgroup,
  }) {
    var postData = {
      deviceGroupId: [deviceGroupId],
      deviceSubGroupId: deviceSubGroupId,
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=devicegroup&a=getGroups", "postData=" + base64Input);
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/deviceGroup/getReportSubGroupAndVehicle", {
        params: postData,
      });

    if (subgroup) {
      // this.subGroupList = response.data.data?.subgroup;
      this.subGroupList = response.data.data[0]?.subgroup;
      this.vehicles = response.data.data[0]?.vehicles;
    } else {
      // this.vehicles = response.data.data?.vehicles;
      this.vehicles = response.data.data[0]?.vehicles;
    }

    return response.data.data[0]?.subgroup;
  }
}

export default EmailReportStore;
